import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import Impressum from '../components/Impressum';
import StructuredData, { breadcrumbStructuredData } from '../components/StructuredData';
import { usePageMeta } from '../hooks/usePageMeta';

const ImpressumPage: React.FC = () => {
  usePageMeta({
    title: 'Impressum | Flugsportverein Otto Lilienthal Bad Langensalza e.V.',
    description: 'Impressum des Flugsportvereins Otto Lilienthal Bad Langensalza e.V., Thamsbrücker Landstraße 28, 99947 Bad Langensalza.',
    path: '/impressum',
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <StructuredData data={breadcrumbStructuredData('Impressum', '/impressum')} />
      <Breadcrumb currentPage="Impressum" />
      <Impressum />
    </div>
  );
};

export default ImpressumPage;
